import React, { useState, useRef, useEffect } from 'react';
import BomName from './BomName';
import BOM from "@system/config/bom";
import { useBOMStore } from "../../../../hooks/bom";
import System from "../../../../helper/system";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import $ from "jquery";
import liveAuth from 'src/helper/liveAuth';
import CreateProject from 'src/pages/BOM/CreateProject';
import { Tooltip } from 'src/component/Global/Tooltip';

const bomId = System.getParams().bomId;
const addFrom = System.getParams().addFrom;

const BomListingHeader = (props) => {
    const dropDownAssignBomRef = useRef();
    const [__check] = useAxiosIndicatorCheck();
    const [projectList, setProjectList] = useState({});
    const [find_project_input_listing, set_find_project_input_listing] = useState('');
    const [{ bom_project_list, bom_detail_by_bom_id, bom_detail_by_bom_id_type }, { fetch_project_list, fetch_bom_project_detail_with_bom, get_bom_detail_by_bom_id }, { bom_assign_to_project, copy_bom_by_bom_id }] = useBOMStore();
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)

    const { storageName } = System

    useEffect(() => {
        async function fetchHere() {
            if (bomId && liveAuth.check()) {
                await fetch_project_list();
            }
            preventProjectAssignDropDownToClose();
        }

        fetchHere()
    }, []);


    useEffect(() => {

        if (bom_detail_by_bom_id?.bomId) {
            if (localStorage.getItem(storageName.BOM_UPLOAD_FILE)) {
                System.setEvars('', '', "BOM upload file", bom_detail_by_bom_id?.bomName, bomId);
            }
            else if (bom_detail_by_bom_id_type?.isExternalBom) {
                System.setEvars('', '', 'Design Hub', bom_detail_by_bom_id?.bomName, bomId)
            } else if (addFrom) {
                let bomSource = '';
                if (addFrom == 'AddPart') {
                    bomSource = 'BOM - Add a part';
                }
                else if (addFrom == 'FindPart') {
                    bomSource = 'BOM - Find a part';
                }
                else {
                    bomSource = addFrom ? addFrom : '';
                }
                System.setEvars('', '', bomSource, bom_detail_by_bom_id?.bomName, bomId)
            }
        }
    }, [bom_detail_by_bom_id?.bomId, bom_detail_by_bom_id_type]);

    useEffect(() => {
        setProjectList(bom_project_list)
    }, [bom_project_list]);
    useEffect(() => {
        if (dropDownAssignBomRef.current) {
            preventProjectAssignDropDownToClose();
        }
    }, [dropDownAssignBomRef]);
    const preventProjectAssignDropDownToClose = () => {
        $(document).on('click', '.dropdown-menu', function (e) {
            e.stopPropagation();
        });
        $(document).on('click', '.dropdown', function (e) {
            e.stopPropagation();
        });
    };
    const getDisplayStatus = (singleProject) => {
        if (!singleProject.projectName.toLowerCase().includes(find_project_input_listing.toLowerCase())) {
            return false
        }
        return true
    };
    const assignProject = async (singleProject) => {
        await bom_assign_to_project({
            bomId, projectId: singleProject.projectId
        });
        closeProjectDropdown();
        await get_bom_detail_by_bom_id({ bomId })
    };

    const closeProjectDropdown = () => {
        let dropdownElem = document.getElementsByClassName('selectbox');
        if (dropdownElem && dropdownElem.length > 0) {
            if (dropdownElem[0].classList.contains('open')) {
                dropdownElem[0].classList.remove('open');
            }
        }
    }

    const searchProject = (array, searchText) => {
        let count = 0;
        Object.entries(array).forEach(x => {
            if (x.length > 0 &&
                x[1].projectName &&
                x[1].projectName.trim() !== '' &&
                x[1].projectName.toLowerCase().includes(searchText.toLowerCase().trim())) {
                ++count;
            }
        });
        return count;
    }
    return (
        <>
            <div className="bom-header">
                <div className="container">
                    <div className="row bs5">
                        <div className="col-sm-6">
                            <div className="d-flex my-2">
                                <a className="me-3 mt-2"
                                    onClick={() => {
                                        if (System.getParams().redirect_back_url && System.getParams().redirect_back_url) {
                                            window.location.href = System.getParams().redirect_back_url;
                                        } else {
                                            window.location.href = BOM.getBomRouteURL()
                                        }
                                    }}><i className="fa fa-angle-double-left" aria-hidden="true"></i> Return to Saved BOMs</a>

                                <div className='bomname'>
                                    <BomName />
                                </div>

                            </div>
                        </div>

                        <div className="col-sm-6 mt-3 mt-sm-0">
                            <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-1 mb-sm-0 mt-2">
                                {__check('BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL', { inline: true }).render}
                                {!__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status && liveAuth.check() && (
                                    !(!isInternalUser && bom_detail_by_bom_id_type?.isExternalBom) && (
                                        <>
                                            {/* Email BOM */}
                                            <li className="ms-0 ms-sm-3">
                                                <a onClick={() => System.popup('DownloadBomPopup', { isEmailPopup: 'yes', single_bom: bom_detail_by_bom_id })}>
                                                    <i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email
                                                </a>
                                            </li>

                                            {/* Download BOM */}
                                            <li className="ms-3">
                                                {props.isBomTab && bom_detail_by_bom_id_type ? (
                                                    bom_detail_by_bom_id_type.totalMatches < 201 ? (
                                                        <a onClick={() => System.popup('DownloadBomPopup', { single_bom: bom_detail_by_bom_id })}>
                                                            <i className="fa fa-download me-2 text-black" />Download
                                                        </a>
                                                    ) : (
                                                        <>
                                                            <a className="disabled-link">
                                                                <i className="fa fa-download me-2 text-black" />Download
                                                            </a>
                                                            <Tooltip
                                                                className="carttooltip"
                                                                position="bottom center"
                                                                opener={() => <i className="fa fa-exclamation-circle font-16 ms-2" />}
                                                                content={() => (
                                                                    <div className="text-center">
                                                                        For BOM larger than 200 parts please use EMAIL BOM
                                                                    </div>
                                                                )}
                                                            />
                                                        </>
                                                    )
                                                ) : null}
                                            </li>

                                            {/* Create Copy */}
                                            <li className="ms-3">
                                                <a
                                                    href={void (0)}
                                                    onClick={async () => {
                                                        if (liveAuth.check()) {
                                                            await copy_bom_by_bom_id({ bomId, source: addFrom });
                                                            let bomLink = document.createElement('a');
                                                            bomLink.href = BOM.getBomRouteURL();
                                                            bomLink.click();
                                                        }
                                                    }}
                                                >
                                                    <i className="copy-icon font-14 me-2 text-black"></i>Create Copy
                                                </a>
                                            </li>
                                        </>
                                    )
                                )}
                            </ul>
                        </div>

                    </div>
                    <div className="pcn-line-divider mb-2" />
                    <div className="row">
                        <div className="bs5 row" onClick={() => {
                            preventProjectAssignDropDownToClose();
                        }}>
                            {liveAuth.check() && <div className="col-auto" onClick={() => {
                                preventProjectAssignDropDownToClose();
                            }}>
                                {__check(['BOM_ASSIGN_TO_PROJECT_API_CALL'], { inline: true }).render}
                                <div ref={dropDownAssignBomRef} className="dropdown selectbox w220" style={{
                                    display: !__check(['BOM_ASSIGN_TO_PROJECT_API_CALL']).status ? 'block' : 'none'
                                }} onClick={() => {
                                    preventProjectAssignDropDownToClose();
                                }}>
                                    <button onClick={() => {
                                        preventProjectAssignDropDownToClose();
                                    }} className="bs5 form-control form-control-sm dropdown-field-btn d-block"
                                        type="button" id="dropdownMenu1-1"
                                        data-toggle="dropdown">
                                        {projectList[bom_detail_by_bom_id.projectId] &&
                                            <>
                                                {projectList[bom_detail_by_bom_id.projectId].projectName}
                                            </>
                                        }
                                        {!projectList[bom_detail_by_bom_id.projectId] &&
                                            <>
                                                Assign to Existing Project
                                            </>
                                        }
                                    </button>

                                    <div className="dropdown-menu dropdown-field-box" id="dropdownMenu1-1">
                                        <div className="input-group mb-2">
                                            <input type="text" className="form-control form-control-sm"
                                                placeholder="Search your projects"
                                                onClick={() => {
                                                    preventProjectAssignDropDownToClose();
                                                }}
                                                onChange={(e) => set_find_project_input_listing(e.target.value)}
                                                aria-label="Search your projects" id="txtSearch" />
                                            <div className="input-group-btn">
                                                <button
                                                    className="bs5 btn btn-secondary btn-sm rounded-1 text-black-stone"
                                                    type="submit">
                                                    <span className="fa fa-search"></span>
                                                </button>
                                            </div>
                                        </div>
                                        {projectList && Object.entries(projectList).length > 0 &&
                                            Object.entries(projectList).map((v, i) => (
                                                <React.Fragment key={v[1].projectId}>
                                                    {getDisplayStatus(v[1]) &&
                                                        <a key={v[1].projectId}
                                                            className="dropdown-item text-black d-block px-0"
                                                            href={void (0)}
                                                            onClick={async () => {
                                                                await assignProject(v[1])
                                                            }}
                                                        >{v[1].projectName}</a>
                                                    }
                                                </React.Fragment>
                                            ))
                                        }
                                        {projectList && Object.entries(projectList).length > 0 &&
                                            find_project_input_listing &&
                                            find_project_input_listing.trim() != '' &&
                                            searchProject(projectList, find_project_input_listing) === 0 &&
                                            <>
                                                <p>Error: No Project Found</p>
                                            </>
                                        }
                                        {projectList && Object.entries(projectList).length === 0 &&
                                            <>
                                                <p>No Project Found</p>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>}
                            {liveAuth.check() && <div className="col-12 mt-2 col-sm-auto mt-sm-0">
                                <CreateProject
                                    afterBOMCreation={async () => {
                                        await fetch_project_list();
                                        await fetch_bom_project_detail_with_bom();
                                        await get_bom_detail_by_bom_id({ bomId })
                                    }}
                                />
                            </div>}
                            {!liveAuth.check() &&
                                <div className="col-auto mt-2 ms-auto mt-sm-0">
                                    <a onClick={() => window.location.href = System.getLoginPageUrl()}><u>Sign in</u></a> to save and quote your BOM
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default BomListingHeader;